<div class="my-4" *ngIf="isVisible">
    <span class="font-weight-bold">{{ 'clubs.page.common.createPublication.rooms.title' | translate }}</span>
    <p>{{ 'clubs.page.common.createPublication.rooms.description' | translate }}</p>

    <p-accordion [style]="{ width: '100%' }">
        <p-accordionTab *ngFor="let club of clubs">
            <ng-template pTemplate="header" class="w-100 h-100 bg-white">
                <span class="d-flex align-items-center">
                    <ng-container *ngIf="club.profilePictureUrl; else textLabel">
                        <p-avatar image="{{ club.profilePictureUrl }}" shape="circle" [style]="{ height: '40px', width: '40px' }"></p-avatar>
                    </ng-container>
                    <span class="ml-2 mr-2 font-bold white-space-nowrap">{{ club.title }}</span>
                    <span class="selected-rooms-counter" *ngIf="getSelectedCount(club.id) > 0">
                        {{ ' - ' + getSelectedCount(club.id) + ' ' + (getSelectedCount(club.id) | i18nPlural : roomMessageMapping) }}
                        <point-marker class="p-my-auto"></point-marker
                    ></span>
                </span>
            </ng-template>
            <div *ngFor="let room of club.room">
                <label class="cursor-pointer d-flex align-items-center mb-0 p-ml-4">
                    <p-checkbox
                        [(ngModel)]="selectedRooms[club.id]"
                        name="group-{{ club.id }}"
                        [value]="room"
                        (ngModelChange)="onRoomSelectionChange()"
                    ></p-checkbox>
                    <span class="ml-2">{{ room.title }}</span>
                </label>
            </div>
            <ng-template #textLabel>
                <div
                    class="d-flex align-items-center justify-content-center"
                    [style]="{ width: '40px', height: '40px', backgroundColor: 'var(--club-gray)', borderRadius: '50%' }"
                >
                    <span [style]="{ color: 'var(--white)' }">
                        {{ club?.title.slice(0, 2).toUpperCase() }}
                    </span>
                </div>
            </ng-template>
        </p-accordionTab>
    </p-accordion>
</div>
